import type { MenuItems } from "@msuite/ui/menu";

/**
 * Drop the entries a capability check removed and the dividers left standing around them.
 *
 * `MenuOptions` renders `null` as nothing and `"divider"` as a separator whichever way, so a menu
 * whose entries are conditional grows stray rules the moment a caller's rules refuse some of
 * them: a group that emptied leaves two dividers touching, and a group at the end leaves one
 * hanging under the last entry. A divider separates groups, so it only earns its line when there
 * is something on both sides of it.
 *
 * @param items - The menu as written, nulls and all.
 * @returns The same menu with the nulls gone and every remaining divider between two entries.
 */
export function tidyDividers(items: MenuItems): MenuItems {
	const present = items.filter((item) => item !== null && item !== undefined);
	return present.filter((item, index) => {
		if (item !== "divider") return true;
		const before = present.slice(0, index).some((entry) => entry !== "divider");
		const after = present.slice(index + 1).some((entry) => entry !== "divider");
		if (!before || !after) return false;
		// Of a run of touching dividers only the first survives.
		return present[index - 1] !== "divider";
	});
}
